var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[(_vm.header.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 head",domProps:{"innerHTML":_vm._s(_vm.header)}})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }